export default __webpack_public_path__ + "static/Row 5.1_SLA-b6075735fb3e93b8eac92f8cd20f8306.jpg";